export default __webpack_public_path__ + "static/media/admin-graph.2de3b5a9.png";